import React, { ButtonHTMLAttributes, FC } from "react";
import { Link } from "react-router-dom";
import { LocationStates } from "routers/types";
import twFocusClass from "utils/twFocusClass";

export interface ButtonProps {
  className?: string;
  translate?: string;
  sizeClass?: string;
  fontSize?: string;
  //
  loading?: boolean;
  disabled?: boolean;
  type?: ButtonHTMLAttributes<HTMLButtonElement>["type"];
  // href?: keyof LocationStates | "#" | LinkProps["to"];
  href?: keyof LocationStates;
  targetBlank?: boolean;
  onClick?: () => void;
  children?: React.ReactNode;
}

const Button: FC<ButtonProps> = ({
  className = "text-neutral-700 disabled:cursor-not-allowed",
  translate = "",
  sizeClass = "py-3 px-4 sm:py-3.5 sm:px-6",
  fontSize = "text-sm sm:text-base font-medium",
  disabled = false,
  href,
  children,
  targetBlank,
  type,
  loading,
  onClick = () => {},
}) => {
  const CLASSES =
    `nc-Button relative h-auto inline-flex items-center justify-center rounded-0 transition-colors border-2 border-slate-200  ${fontSize} ${sizeClass} ${translate} ${className} ` +
    twFocusClass(true) +
    ` group overflow-hidden hover:border-[#fece40] hover:text-[#000]`;

  const _renderLoading = () => {
    return (
      <svg
        className="animate-spin -ml-1 mr-3 h-5 w-5"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="3"
        ></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
    );
  };

  const ButtonContent = () => (
    <>
      <span className="absolute left-0 top-0 h-full w-0 bg-[#fece40] transition-all duration-300 ease-out group-hover:w-full "></span>
      <span className="relative flex items-center justify-center gap-0.5 tracking-wider text-sm">
        {loading && _renderLoading()}
        {children || `This is Button`}
      </span>
    </>
  );

  if (!!href) {
    return (
      <Link
        to={href}
        target={targetBlank ? "_blank" : undefined}
        className={`${CLASSES}`}
        onClick={onClick}
        rel="noopener noreferrer"
      >
        <ButtonContent />
      </Link>
    );
  }

  return (
    <button
      disabled={disabled || loading}
      className={`${CLASSES}`}
      onClick={onClick}
      type={type}
    >
      <ButtonContent />
    </button>
  );
};

export default Button;
